import { NetworkHelper } from "clariant-helpers-vue3";

export default class DataLayer {
    constructor(config, state, utils) {
        this.config = config;
        this.state = state;
        this.utils = utils;
    }
    getLabels() {
        return NetworkHelper.get(`${this.config.wsRootUrl}/commontexts/group${this.config.isDevEnvironment ? ".json" : ""}?id=${this.config.commonTextsRoot}`);
    }
    getContactDetails(id) {
        if (!id) return Promise.reject({ message: "Invalid id for a contact! Try again!" });
        return NetworkHelper.get(`${this.config.wsRootUrl}/contact${this.config.isDevEnvironment ? ".json" : ""}?id=${id}`);
    }
    findContactByTag(tag, country, region) {
        if (!tag) return Promise.reject({ message: "Invalid tag for a contact! Try again!" });
        return NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/byTag${this.config.isDevEnvironment ? ".json" : ""}?tag=${encodeURIComponent(tag)}&country=${encodeURIComponent(country)}`);
    }
    findContactByOrg(bu, bl, country, region) {
        if (!bu && !bl) return Promise.reject({ message: "Invalid org info for a contact! Try again!" });
        return NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/byOrg${this.config.isDevEnvironment ? ".json" : ""}?bu=${encodeURIComponent(bu)}&bl=${encodeURIComponent(bl)}&country=${encodeURIComponent(country)}`);
    }
    findContactByProduct(productId, country, region) {
        if (!productId) return Promise.reject({ message: "Invalid product id for finding a contact! Try again!" });
        return NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/byProduct${this.config.isDevEnvironment ? ".json" : ""}?id=${encodeURIComponent(productId)}&country=${encodeURIComponent(country)}`);
    }
    loadContacts(tag) {
        if (!tag) return Promise.reject({ message: "Invalid tag for contacts! Try again!" });
        return NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/byTagAll${this.config.isDevEnvironment ? ".json" : ""}?tag=${encodeURIComponent(tag)}`);
    }
    loadProducts(query, hasSampleAvailable) {
        let url = `${this.config.wsRootUrl}/contactsdata/products${this.config.isDevEnvironment ? ".json" : ""}?filter=${encodeURIComponent(query)}&top=10000`;
        if (hasSampleAvailable) url += "&hassample=true";
        return NetworkHelper.get(url);
    }
    loadBusinessLines() {
        const vals = this.state.get("businessLines");
        if (vals && vals.length > 0) return vals;
        else {
            NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/businessLines${this.config.isDevEnvironment ? ".json" : ""}`)
                .then(res => {
                    this.state.set("businessLines", res.data)
                }).catch(err => {
                    this.utils.showStatusMessage(err.message, "red");
                });
            return [];
        }
    }
    loadBusinessUnits() {
        const vals = this.state.get("businessUnits");
        if (vals && vals.length > 0) return vals;
        else {
            NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/businessUnits${this.config.isDevEnvironment ? ".json" : ""}`)
                .then(res => {
                    /* Temp hack */
                    let actualBus = res.data.filter(x => x.name !== "Masterbatches" && x.name !== "New Business Development");
                    /* End temp hack */
                    this.state.set("businessUnits", actualBus);
                }).catch(err => {
                    this.utils.showStatusMessage(err.message, "red");
                });
            return [];
        }
    }
    loadCountries() {
        const vals = this.state.get("countries");
        if (vals && vals.length > 0) return vals;
        else {
            NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/countries${this.config.isDevEnvironment ? ".json" : ""}`)
                .then(res => {
                    this.state.set("countries", res.data)
                }).catch(err => {
                    this.utils.showStatusMessage(err.message, "red");
                });
            return [];
        }
    }
    loadRequestTypes() {
        const vals = this.state.get("requestTypes");
        if (vals && vals.length > 0) return vals;
        else {
            NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/requestTypes${this.config.isDevEnvironment ? ".json" : ""}`)
                .then(res => {
                    this.state.set("requestTypes", res.data)
                }).catch(err => {
                    this.utils.showStatusMessage(err.message, "red");
                });
            return [];
        }
    }
    loadICSMetadata() {
        const jobTitles = this.state.get("jobTitles");
        const departments = this.state.get("departments");
        const companyTypes = this.state.get("companyTypes");
        const industries = this.state.get("industries");
        if (jobTitles && jobTitles.length > 0 &&
            departments && departments.length > 0 &&
            companyTypes && companyTypes.length > 0 &&
            industries && industries.length > 0) return { jobTitles, departments, companyTypes, industries };
        else {
            NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/icsMetadata${this.config.isDevEnvironment ? ".json" : ""}`)
                .then(res => {
                    this.state.set("jobTitles", res.data.jobTitles);
                    this.state.set("departments", res.data.departments);
                    this.state.set("companyTypes", res.data.companyTypes);
                    this.state.set("industries", res.data.industries);
                }).catch(err => {
                    this.utils.showStatusMessage(err.message, "red");
                });
            return [];
        }
    }
    loadCatalystsMetadata() {
        const applications = this.state.get("applications");
        if(applications && applications.length > 0) return applications;
        else {
            NetworkHelper.get(`${this.config.wsRootUrl}/contactsdata/catalystsMetadata${this.config.isDevEnvironment ? ".json" : ""}`)
            .then(res => {
                this.state.set("applications", res.data.applications);
            })
            .catch(err => {
                this.utils.showStatusMessage(err.message, "red");
            })
        }
    }
    submitForm(payload) {
        if (!payload) return Promise.reject({ message: "Cannot submit an empty contact form!" });
        let url = `${this.config.wsRootUrl}/lead/save${this.config.isDevEnvironment ? ".json" : ""}`
        return NetworkHelper.post(url, payload);
    }
    loadTaxonomy() {
        let url = `${this.config.wsRootUrl}/contactsdata/taxonomy${this.config.isDevEnvironment ? ".json" : ""}`
        return NetworkHelper.get(url);
    }
    loadOrgUnits() {
        let url = `${this.config.wsRootUrl}/contactsdata/org${this.config.isDevEnvironment ? ".json" : ""}`
        return NetworkHelper.get(url);
    }
    getSuitableContact(contactId, buId, blId, tagId) {
        let self = this;
        return new Promise((resolve, reject) => {
            let promise = null;
            if (contactId) {
                promise = self.getContactDetails(contactId);
            } else if (buId || blId) {
                promise = self.findContactByOrg(
                    this.utils.toShortId(buId),
                    this.utils.toShortId(blId),
                    this.state.current.country,
                    this.state.current.region
                );
            } else if (tagId) {
                promise = self.findContactByTag(
                    this.utils.toShortId(tagId),
                    this.state.current.country,
                    this.state.current.region
                );
            } else {
                promise = self.getContactDetails(this.config.defaultContactId);
            }

            promise.then(res => {
                if (!res.data || (Array.isArray(res.data) && res.data.length === 0)) {
                    self.loadContactDetails(this.config.defaultContactId).then(res => {
                        resolve(res);
                    }).catch(err => reject(err));
                } else {
                    const ret = {data: Array.isArray(res.data) ? res.data[0] : res.data};
                    resolve(ret);
                }
            }).catch(err => reject(err));
        })
    }
}
